export type OrderStatus =
  | 'indent_raised'
  | 'order_placed'
  | 'payment_received'
  | 'order_confirmed'
  | 'in_progress'
  | 'dispatched'
  | 'delivered'

const VALID_ORDER_STATUSES = new Set<string>([
  'indent_raised',
  'order_placed',
  'payment_received',
  'order_confirmed',
  'in_progress',
  'dispatched',
  'delivered',
])

export const normalizeOrderStatus = (rawStatus: string): OrderStatus | null =>
  VALID_ORDER_STATUSES.has(rawStatus) ? (rawStatus as OrderStatus) : null

export interface OrderAddress {
  street: string
  city: string
  state: string
  zip: string
}

export const formatOrderAddress = (address: OrderAddress): string =>
  [address.street, address.city, address.state, address.zip].filter(Boolean).join(', ')

export interface OrderBuyer {
  id: string
  name: string
  businessName?: string
  phone: string
  email: string
  role: string
}

export interface OrderItem {
  id: string
  catalogItemId: string
  productName: string
  variant: string
  unit?: string
  units: number
  qty: number
  unitPrice?: number
  subtotal?: number
  moq?: number
  catalogItemDeleted?: boolean
}

export interface OrderPayment {
  id: string
  amount: number
  paymentDate?: string
  paymentMode: string
  status: string
  screenshotUrl?: string
  verifiedAt?: string
  rejectionReason?: string
}

export interface OrderListItem {
  id: string
  status: OrderStatus
  version: number
  paymentMode: string
  orderPlacedDate: string
  requestedDeliveryDate?: string
  totalAmount?: number
  billToAddress: OrderAddress
  shipToAddress: OrderAddress
  buyer?: OrderBuyer
  paymentStatus: string
  moqCheck: boolean
  isRepeat: boolean
  hasGrievance: boolean
  items?: OrderItem[]
  totalUnits?: number
  createdAt: string
  updatedAt: string
}

export interface StatusHistoryEntry {
  status: OrderStatus
  changedAt: string
}

export interface OrderDetail {
  id: string
  status: OrderStatus
  version: number
  moqCheck: boolean
  moqWarning: boolean
  isRepeat: boolean
  hasGrievance: boolean
  paymentMode: string
  orderPlacedDate: string
  requestedDeliveryDate?: string
  totalAmount?: number
  remarks?: string
  billToAddress: OrderAddress
  shipToAddress: OrderAddress
  buyer?: OrderBuyer
  payments: OrderPayment[]
  items: OrderItem[]
  statusHistory: StatusHistoryEntry[]
  createdAt: string
  updatedAt: string
}
